import axios from 'axios';
import React, { useState, useEffect } from 'react'
import { Button, Col, Form, InputGroup, Modal, Row, Spinner } from 'react-bootstrap';
import * as Icon from "react-bootstrap-icons";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from "react-select";
import { useSelector } from 'react-redux';
import useGetAssignTo from '../ReuseApi/useGetAssignTo';
import { useNavigate } from 'react-router-dom';
import useGetDeptWiseResource from '../ReuseApi/UseGetDeptWiseAssignTo';
import useGetAllCategories from '../ReuseApi/useGetAllCategories';
import useGetSubDepartments from '../ReuseApi/useGetSubDepartments';

export const AssignAllocatedTaskModel = ({ show, close, data }) => {

  const navigate = useNavigate()
  const loginUserData = useSelector((state) => state.loginData.userData)
  const userDept = loginUserData?.department.map((itm) => { return itm.label }).toString()
  const activeTabName = useSelector((state) => state.activeData?.activeNumberKey?.activeTab);
  const userDepartment = (loginUserData?.department || []).map(item => ({
    value: item.value,
    label: item.label
  }));

  console.log("data", data, activeTabName)
  const userDataDept = loginUserData.department.map((itm) => { return itm.label }).toString()

  const [localDeptOptions, setLocalDeptOptions] = useState({
    data: [],
    selectedListInd: null,
    selectedOptionInd: null
  });

  const [departmentName, setDepartmentName] = useState([])
  const [subDepartment, setSubDepartment] = useState("")
  const [assignto, setAssignto] = useState("")
  const [taskdesc, setTaskDesc] = useState("")
  const [taskinitialestihr, setTaskInitialEstimateHr] = useState("");
  const [taskinitialminute, setTaskInitialMinute] = useState("");
  const [categoryname, setCategoryname] = useState("")
  const [errors, setErrors] = useState({});

  // state for error
  const [deprtError, setDeprtError] = useState(false)
  const [assignToError, setAssignToError] = useState(false)
  const [taskdescerr, setTaskDescErr] = useState(false)
  const [taskinitialestihrerror, setTaskInitialEstimateHrError] = useState(false);
  const [taskinitialminuteerr, settaskInitialMinuteErr] = useState(false)

  const [assignToOptions, setAssignToOptions] = useState([])

  const { allCategoriesOptions } = useGetAllCategories(departmentName, subDepartment)
  const { subDeptOptions } = useGetSubDepartments(departmentName?.value);

  useEffect(() => {
    const fetchDeptAndAssignToOptions = async () => {
      const payload = userDataDept !== userDept ?
        {
          departmentName: departmentName ? departmentName.label : "",
          subDepartment: subDepartment ? subDepartment.label : "",
        }
        :
        {
          departments: "",
          subDepartment: "",
          empId: loginUserData?.empId
          // departments: departmentName?.label ? [departmentName.label] : loginUserData.department.map((itm) => itm.label),
          // subDepartment: subDepartment ? [subDepartment] : loginUserData.subDepartmentName.map((itm) => itm),
          // empId: loginUserData?.empId
        };
      const urlEndpoint = '/emp/getEmployeeByDepartment';

      axios.post(process.env.REACT_APP_BASE_URL + urlEndpoint, payload)
        .then((res) => {
          const deptOptions = [];
          const assignToOptions = [];

          // const filterOption = (res?.data?.data)?.length > 0 && (res?.data?.data)?.map((itm) => {
          //     return ({ value: itm.empId, label: `${itm.firstName} ${itm.lastName}` })
          // })

          if (res?.data?.data?.length) {
            res.data.data.forEach(item => {
              const userObj = {
                label: `${item.firstName} ${item.lastName}`,
                value: item.empId
              }

              deptOptions.push(item.department)
              assignToOptions.push(userObj)
            })
          }

          // if (filterOption?.length > 0) {
          //     setAllAssignToOptions(filterOption)
          // }

          setLocalDeptOptions({
            data: deptOptions,
            selectedListInd: null,
            selectedOptionInd: null
          });
          setAssignToOptions(assignToOptions);
        })
        .catch((err) => {
          console.log("Error", err)
        })
    }

    fetchDeptAndAssignToOptions();

  }, [])


  const AddTaskSuccess = () => {
    toast.success("Assigned Task Successfully", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1000,
      toastId: "assign-task-success",
      onClose: () => {
        setTimeout(() => {
          navigate(`/${loginUserData.resourceType}/employee-task`);
        }, 1000);
      }
    });
  };

  const AlreadyTaskAdd = () => {
    toast.error("Task Already Assigned", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1000,
    });
  };

  const AddActualHoursSuccess = () => {
    toast.error("Please Insert less than initial Estimate Hours", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1000,
    });
  };

  const InitialHrMinute = () => {
    toast.error("00 hours and 00 minutes at the same time are not permitted, please choose an acceptable time.", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1000,
      toastId: "initial-hr-minute-error"
    });
  }

  // for validation
  const handlerValidate = () => {
    let newErrors = {};
    if (!departmentName) newErrors.departmentName = "Required Field";
    if (subDeptOptions.length > 0 && !subDepartment) newErrors.subDepartment = "Required Field";
    if (!assignto) newErrors.assignto = "Required Field";
    if (!taskdesc) newErrors.taskdesc = "Required Field";
    if (!taskinitialminute) newErrors.taskinitialminute = "Required Field";
    if (!taskinitialestihr) newErrors.taskinitialestihr = "Required Field";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    setDeprtError(false)
    setAssignToError(false)
    setTaskDescErr(false)
    setTaskInitialEstimateHrError(false)
    settaskInitialMinuteErr(false)
    settaskInitialMinuteErr(false)

    if (handlerValidate()) {
      if (parseFloat(taskinitialestihr) === 0 && parseFloat(taskinitialminute) === 0) {
        InitialHrMinute();
        return
      }
      // const parentMinutes = Number(data?.initialEstimateHr || 0) * 60;
      const parentMinutes = Math.round(
        (Number(data?.initialEstimateHr || 0) * 60) +
        Number(data?.initialEstimateMinutes || 0)
      );

      const enteredHours = Number(taskinitialestihr || 0);
      const enteredMinutes = Number(taskinitialminute || 0);

      const totalEnteredMinutes = (enteredHours * 60) + enteredMinutes;

      const usedMinutes = Number(data?.usedMinutes || 0);

      if ((usedMinutes + totalEnteredMinutes) > parentMinutes) {
        toast.error("You exceeded the allowed task time (Initial Estimate)");
        return;
      }
      const payload = {
        empId: assignto.value,
        taskName: data.taskName,
        taskPriority: data.taskPriority,
        taskDescription: taskdesc,
        taskDepartmentId: departmentName.value,
        taskDepartmentName: departmentName.label,
        department_id: (loginUserData?.department).some((itm) => itm.label === departmentName.label) ? departmentName.value : loginUserData?.department[0]?.value,
        departmentName: (loginUserData?.department).some((itm) => itm.label === departmentName.label) ? departmentName.label : loginUserData?.department[0]?.label,
        subDepartmentId: subDepartment?.value,
        subDepartmentName: subDepartment?.label,
        projectId: data.projectname,
        projectName: data.projectName,
        categoryOfName: categoryname?.label,
        category_id: categoryname?.value,
        resource_id: assignto.value,
        resourceName: assignto.label,
        assignBy_id: data?.empId,
        assignBy_Name: `${loginUserData.firstName} ${loginUserData.lastName}`,
        proposedStartDate: new Date(data.proposedStartDate).toISOString().split('T')[0],
        proposedEndDate: new Date(data.proposedEndDate).toISOString().split('T')[0],
        initialEstimateHr: taskinitialestihr,
        initialEstimateMinutes: taskinitialminute,
        headTaskId: data.taskId,
        headTaskName: data.taskName,
        headTaskDescription: data.taskDescription,
        headTaskPriority: data.taskPriority,
        headProjectId: data.projectId,
        headProjectName: data.projectName,
        // oldTaskId: data?.isTaskAssigned === true ? data?.taskId : ""
        oldTaskId:
          activeTabName === "Task Assigned From Other Dept"
            ? data?.isOtherDeptTaskAssigned
              ? data?.taskId
              : ""
            : data?.isTaskAssigned
              ? data?.taskId
              : ""
        // oldTaskId:
        //   activeTabName === "Other Department Task" &&
        //     (data?.isOtherDeptTaskAssigned || data?.isTaskAssigned)
        //     ? data?.taskId
        //     : ""

      }


      axios.post(process.env.REACT_APP_NEW_BASE_URL + '/assignTask', payload)
        .then((res) => {
          AddTaskSuccess();
          close()
        })
        .catch((err) => {
          console.log("Error", err)
        })
    }
  }


  const payload = {
    "departments": departmentName?.label ? [departmentName.label] : loginUserData.department.map((itm) => itm.label),
    "empId": ""
  };
  const urlEndpoint = "/emp/getEmployeeByDepartment"

  const { allAssignToOptions } = useGetDeptWiseResource(urlEndpoint, payload, departmentName, loginUserData?.department.map((itm) => itm.label))

  return (
    <>
      <Modal show={show} onHide={close} size="lg" centered backdrop='static' keyboard={false}>
        <Modal.Header closeButton className="mngmodelheader">
          <Modal.Title><h5>Assign Task</h5></Modal.Title>
        </Modal.Header>
        <Modal.Body size="lg">
          <Row className='mb-4'>
            <Col sm={12} md={4}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Assign To
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={assignto}
                  options={assignToOptions}
                  onChange={(option) => {
                    const index = assignToOptions.findIndex(
                      (itm) => itm.value === option.value && itm.label === option.label
                    );
                    setLocalDeptOptions((prev) => ({
                      ...prev,
                      selectedListInd: index,
                      selectedOptionInd: 0,
                    }));
                    setDepartmentName(localDeptOptions.data[index][0]);
                    setAssignto(option);
                  }}
                />
                {errors.assignto && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.assignto}
                  </p>
                )}
              </Form.Group>
            </Col>
            <Col sm={12} md={4}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Department Name
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={departmentName}
                  options={localDeptOptions.selectedListInd != null ? localDeptOptions.data[localDeptOptions.selectedListInd] : []}
                  isDisabled={localDeptOptions.selectedOptionInd === null}
                  onChange={(option) => {
                    const optionIndex = localDeptOptions.data[localDeptOptions.selectedListInd].findIndex(
                      (itm) => itm.value === option.value && itm.label === option.label
                    );
                    setLocalDeptOptions((prev) => ({
                      ...prev,
                      selectedOptionInd: optionIndex,
                    }));
                    setDepartmentName(option);
                    setSubDepartment(null);
                  }}
                />
                {errors.departmentName && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.departmentName}
                  </p>
                )}
              </Form.Group>
            </Col>
            <Col sm={12} md={4}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Sub Department Name
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={subDepartment}
                  options={subDeptOptions}
                  isDisabled={!departmentName || subDeptOptions.length === 0}
                  onChange={(option) => {
                    setSubDepartment(option);
                    setCategoryname(null);
                  }}
                />
                {errors.subDepartment && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.subDepartment}
                  </p>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row className='mb-4'>
            <Col sm={12} md={6}>
              <Form.Group controlId="formBasicId">
                <Form.Label className="mt-3 fw-bold">
                  Task Title
                  <span className="requiredfield">*</span>
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    style={{ backgroundColor: "#f0f0f0" }}
                    placeholder="Task Name"
                    className="input-field project-inputgroup"
                    name="taskName"
                    value={data?.taskName}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col sm={12} md={6}>
              <Form.Group className="">
                <Form.Label className="emp-form-label mt-3 fw-bold">
                  Task Priority
                  <span className="requiredfield">*</span>
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    style={{ backgroundColor: "#f0f0f0" }}
                    placeholder="Task Name"
                    className="input-field project-inputgroup"
                    name="taskPriority"
                    value={data?.taskPriority}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>
          <Row className='mb-4'>
            <Col sm={12} md={12}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Task Description{" "}
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Task Description"
                  name='taskdesc'
                  value={taskdesc}
                  onChange={(e) => {
                    setTaskDesc(e.target.value);
                    taskdesc.length >= 0
                      ? setTaskDescErr(false)
                      : setTaskDescErr(true);
                  }}
                />
              </Form.Group>
              {errors.taskdesc && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  {errors.taskdesc}
                </p>
              )}
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col sm={12} md={6}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Project Name
                  <span className="requiredfield">*</span>
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    style={{ backgroundColor: "#f0f0f0" }}
                    name='projectName'
                    value={data?.projectName}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col sm={12} md={6}>
              <Form.Group className="">
                <Form.Label className="emp-form-label mt-3 fw-bold">
                  Category Name
                  {/* <span className="requiredfield">*</span> */}
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={categoryname}
                  options={allCategoriesOptions}
                  isDisabled={!departmentName || !subDepartment}
                  onChange={(option) => {
                    setCategoryname(option);
                  }}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" className="w-100">
                <Form.Label className="mt-3 fw-bold">
                  Proposed Start date{" "}
                  <span className="requiredfield">*</span>
                </Form.Label>
                <InputGroup className="mb-2">
                  <Form.Control
                    style={{ backgroundColor: "#f0f0f0" }}
                    name="proposedStartDate"
                    value={data?.proposedStartDate ? new Date(data?.proposedStartDate).toISOString().split("T")[0] : ""}
                  />
                </InputGroup>
              </Form.Group>
            </Col>

            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" style={{ width: "100%" }}>
                <Form.Label className="mt-3 fw-bold">
                  Proposed End date{" "}
                  <span className="requiredfield">*</span>
                </Form.Label>
                <InputGroup className="mb-2">
                  <Form.Control
                    style={{ backgroundColor: "#f0f0f0" }}
                    name='proposedEndDate'
                    value={data?.proposedEndDate ? new Date(data?.proposedEndDate).toISOString().split("T")[0] : ""}
                  />
                </InputGroup>
              </Form.Group>
            </Col>

            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" style={{ width: "100%" }}>
                <Form.Label className="mt-3 fw-bold">
                  Initial Estimate(Hours){" "}
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="initialEstimateHr"
                  placeholder='Initial Estimate in Hours'
                  value={taskinitialestihr}
                  onChange={(e) => {
                    if (/^[0-9]*(\.[0-9]*)?$/.test(e.target.value) && e.target.value.length <= 4) {
                      setTaskInitialEstimateHr(e.target.value);
                    } else if (e.target.value.length === 0) {
                      setTaskInitialEstimateHr(e.target.value);
                    }
                  }}
                />
                {errors.taskinitialestihr && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.taskinitialestihr}
                  </p>
                )}
              </Form.Group>
            </Col>


            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" style={{ width: "100%" }}>
                <Form.Label className="mt-3 fw-bold">
                  Initial Minutes
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  className=""
                  name="initialEstimateMinutes"
                  placeholder='Initial Estimate in Minutes'
                  value={taskinitialminute}
                  onChange={(e) => {
                    if (/^[0-9]{0,2}$/.test(e.target.value) && e.target.value >= 0 && e.target.value <= 59) {
                      setTaskInitialMinute(e.target.value);
                    } else if (e.target.value > 59) {
                      toast.error('Please enter a value between 0 and 59.')
                    }
                    else if (e.target.value.length === 0) {
                      setTaskInitialMinute(e.target.value);
                    }
                  }}
                />
              </Form.Group>
              {errors.taskinitialminute && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  {errors.taskinitialminute}
                </p>
              )}
            </Col>
          </Row>

        </Modal.Body>

        <Modal.Footer className="text-center mt-4">
          <Button className="primaryBtn "
            onClick={() => { handleSubmit() }}
          >
            <Icon.PersonAdd className='me-2' /> Create Task
          </Button>

        </Modal.Footer>

      </Modal>
    </>
  )

}
